import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { State } from "../../common/selectOption/selectOption";
import { useAddSupplierMutation, useUpdateSupplierMutation } from "../../redux/api/userApi";
import * as Yup from "yup";
import { useFormik } from "formik";
const supplierSchema = Yup.object().shape({
  supplierName: Yup.string().required('Supplier Name is required'),
  phone: Yup.string()
  .required('Phone Number is required')
  .matches(
    /^[6-9]\d{9}$/,
    'Phone Number must be a valid 10-digit Indian mobile number'
  ),
  email: Yup.string()
    .email('Invalid email address'),
  city: Yup.string(),
  state: Yup.string(),
  address: Yup.string(),
  postalCode: Yup.string(),
  status: Yup.boolean().default(true)
});
const SupplierModal = ({ isEdit = false, supplierData = null,  onSuccess = () => {} }) => {
  const [addSupplier] = useAddSupplierMutation();
  const [updateSupplier] = useUpdateSupplierMutation();
  const [isReady, setIsReady] = useState(false);
  console.log("isedit", supplierData); 
  const formik = useFormik({
    initialValues: {
      supplierName: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      state: '',
      postalCode: '',
      status: true
    },
    validationSchema: supplierSchema,
 onSubmit: async (values, { setSubmitting, resetForm }) => {
  try {
    const promise = isEdit && supplierData
      ? updateSupplier({ id: supplierData._id, ...values }).unwrap()
      : addSupplier(values).unwrap();

    await toast.promise(promise, {
      loading: isEdit ? 'Updating supplier...' : 'Adding supplier...',
      success: () => {
        onSuccess();
        resetForm();
        return isEdit ? 'Supplier updated!' : 'Supplier added!';
      },
      error: (error) => {
        console.error('Error:', error.data || error);
        return error.data?.message || 'Operation failed';
      }
    });
  } finally {
    setSubmitting(false);
  }
}
  });

 

  useEffect(() => {
  if (isEdit && supplierData) {
    console.log("Initializing form with:", supplierData);
    formik.setValues({
      supplierName: supplierData.supplierName || '',
      email: supplierData.email || '',
      phone: supplierData.phone || '',
      address: supplierData.address || '',
      city: supplierData.city || '',
      state: supplierData.state || '',
      postalCode: supplierData.postalCode || '',
      status: supplierData.status !== undefined ? supplierData.status : true
    });
  } else if (!isEdit) {
    formik.resetForm();
  }
}, [isEdit, supplierData]); // Watch for changes in the entire supplierData object

// 3. Modify your submit handler to properly handle the modal dismissal
const handleSubmit = async (values, { setSubmitting, resetForm }) => {
  try {
    if (isEdit && supplierData) {
      await updateSupplier({ id: supplierData._id, ...values }).unwrap();
    } else {
      await addSupplier(values).unwrap();
    }
    
    onSuccess();
    // Don't reset form here - let the modal close handler do it
  } catch (error) {
    console.error('Error:', error);
    // Add user feedback here
  } finally {
    setSubmitting(false);
  }
};
  const handleStatusChange = (e) => {
    formik.setFieldValue('status', e.target.checked);
  };
  console.log("  value={formik.values.supplierName}", formik.values.supplierName);
  return (
    <div>
      <>
        {/* Add Supplier */}
        <div className="modal fade" id="add-supplier">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div className="page-title">
                <h4>{isEdit ? 'Edit Supplier' : 'Add Supplier'}</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    formik.resetForm();
                    // setIsInitialized(false);
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Supplier Name <span className="text-danger">*</span>
                      </label>
                      <input 
                        type="text" 
                        className={`form-control ${formik?.touched?.supplierName && formik?.errors?.supplierName ? 'is-invalid' : ''}`}
                        name="supplierName"
                        value={formik?.values?.supplierName}
                        onChange={formik?.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.supplierName && formik.errors.supplierName && (
                        <div className="invalid-feedback">{formik.errors.supplierName}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Email <span className="text-danger"></span>
                      </label>
                      <input 
                        type="email" 
                        className={`form-control ${formik.touched.email && formik.errors.email ? 'is-invalid' : ''}`}
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="invalid-feedback">{formik.errors.email}</div>
                      )}
                    </div>
                  </div>
                
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Phone <span className="text-danger">*</span>
                      </label>
                      <input 
                        type="text" 
                        className={`form-control ${formik.touched.phone && formik.errors.phone ? 'is-invalid' : ''}`}
                        name="phone"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.phone && formik.errors.phone && (
                        <div className="invalid-feedback">{formik.errors.phone}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Address <span className="text-danger"></span>
                      </label>
                      <input 
                        type="text" 
                        className={`form-control ${formik.touched.address && formik.errors.address ? 'is-invalid' : ''}`}
                        name="address"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.address && formik.errors.address && (
                        <div className="invalid-feedback">{formik.errors.address}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">City</label>
                      <input 
                        type="text" 
                        className="form-control"
                        name="city"
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">State</label>
                      <Select
                        options={State}
                        classNamePrefix="select"
                        name="state"
                        value={State.find(option => option.value === formik.values.state)}
                        onChange={(option) => formik.setFieldValue('state', option.value)}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">Postal Code</label>
                      <input 
                        type="text" 
                        className="form-control"
                        name="postalCode"
                        value={formik.values.postalCode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-0">
                      <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                        <span className="status-label">Status</span>
                        <input
                          type="checkbox"
                          id="supplier-status"
                          className="check"
                          checked={formik.values.status}
                          onChange={handleStatusChange}
                        />
                        <label htmlFor="supplier-status" className="checktoggle mb-0" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    formik.resetForm();
                    // setIsInitialized(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary fs-13 fw-medium p-2 px-3"
                  disabled={formik.isSubmitting}
                   data-bs-dismiss="modal"
                >
                  {formik.isSubmitting ? 'Processing...' : isEdit ? 'Update Supplier' : 'Add Supplier'}
                </button>
              </div>
            </form>
            </div>
          </div>
        </div>
        {/* /Add Supplier */}
      </>

    </div>
  );
};

export default SupplierModal;
